import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Select';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "select"
    }}>{`Select`}</h1>
    <p>{`Accessible and themeable form select component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Label, Select } from '@rebass/forms'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box>
  <Label htmlFor='country'>Country</Label>
  <Select
    id='country'
    name='country'
    defaultValue='United States'>
    {Object.entries(props.countries).map(([ key, country ]) => (
      <option
        key={key}>
        {country.name}
      </option>
    ))}
  </Select>
</Box>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      